module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remarkContainer"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "remarks-boder",
    attrs: {
      "maxlength": "100",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }, function($event) {
        return _vm.changeComment()
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-28",
    staticStyle: {
      "color": "#787878",
      "margin-top": ".1rem",
      "margin-left": ".2rem"
    }
  }, [_vm._v("快捷标签")]), _vm._v(" "), _c('div', {
    staticClass: "remark-tag"
  }, _vm._l((_vm.remarkList), function(item) {
    return _c('div', {
      staticClass: "tag-items ellipse",
      on: {
        "click": function($event) {
          return _vm.addTips(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn btn-main btn-lg btn-block",
    staticStyle: {
      "margin": ".2rem auto",
      "width": "7.1rem"
    },
    on: {
      "click": function($event) {
        return _vm.toOrder()
      }
    }
  }, [_vm._v("完 成")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5fd7f123","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/OutRemarks.vue
// module id = 443
// module chunks = 7